import { useRoute } from "wouter";
import { KeywordExplorer as KeywordExplorerContent } from "@/features/content/KeywordExplorer";

export function KeywordExplorer() {
  const [, params] = useRoute("/projects/:id/content/keywords");
  const projectId = params?.id ? parseInt(params.id, 10) : null;
  if (!projectId) return null;
  return <KeywordExplorerContent projectId={projectId} />;
}
